import type { Scene, Clip } from "@/types/type";

export function genId(type: string, clips: Pick<Clip, "id">[]): string {
  const timestamp: number = Date.now();
  const random: number = Math.floor(Math.random() * 1000);
  const id = `${type}-${timestamp.toString(32)}${random.toString(32)}`;
  if (clips.some((clip) => clip.id === id)) {
    return genId(type, clips);
  }
  return id;
}

/**
 * 중복 없는 씬 아이디 생성 (이미 생성된 씬 리스트를 넘기는 경우)
 */
export function genSceneId(scenes: (Scene | undefined)[] = []) {
  const timestamp: number = Date.now();
  const random: number = Math.floor(Math.random() * 1000);
  const id = `scene-${timestamp.toString(32)}${random.toString(32)}`;
  if (scenes.some((scene) => scene?.id === id)) {
    return genSceneId(scenes);
  }
  return id;
}